module.exports = __webpack_public_path__ + "img/logo2.7879a2ec.png";